var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsSansSerifBold2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20230101 at Fri Sep  5 11:47:58 2025\n By Rapha\xEBl Renaudon\nCopyright lou 2017\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "MS-Sans-Serif",
    horizAdvX: 2428
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "MS Sans Serif",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 4096,
    panose1: "0 0 4 0 0 0 0 0 0 0",
    ascent: 3276,
    descent: -820,
    xHeight: 2233,
    capHeight: 3351,
    bbox: "95 -744 4561 4100",
    underlineThickness: 204,
    underlinePosition: 103,
    unicodeRange: "U+0020-201D"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 3545,
    d: "M1772 475v533h-533v-533h533zM2305 1099v532h-1066v-532h1066zM1772 1719v532h-533v-532h533zM2305 2342v529h-533q-221 0 -375 -154q-158 -157 -158 -375h1066zM97 0v3351h3351v-3351h-3351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 3545,
    d: "M1772 475v533h-533v-533h533zM2305 1099v532h-1066v-532h1066zM1772 1719v532h-533v-532h533zM2305 2342v529h-533q-221 0 -375 -154q-158 -157 -158 -375h1066zM97 0v3351h3351v-3351h-3351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph1",
    horizAdvX: 194
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph2",
    horizAdvX: 194
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 741
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 566,
    d: "M97 0v372h372v-372h-372zM97 744v2607h372v-2607h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 1683,
    d: "M97 2234v1117h372v-1117h-372zM1214 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    d: "M1586 1117v1117h-745v-1117h745zM469 0v744h-372v373h372v1117h-372v372h372v745h372v-745h745v745h372v-745h373v-372h-373v-1117h373v-373h-373v-744h-372v744h-745v-744h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 2055,
    d: "M97 372v372h372v-372h-372zM1586 372v745h372v-745h-372zM97 1861v745h372v-745h-372zM1586 2234v372h372v-372h-372zM841 -372v372h-372v372h372v1117h-372v372h372v745h-372v372h372v373h373v-373h372v-372h-372v-1117h372v-372h-372v-745h372v-372h-372v-372h-373z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 2800,
    d: "M1586 0v372h745v-372h-745zM97 372v372h372v-372h-372zM1214 372v372h372v-372h-372zM2331 372v372h372v-372h-372zM469 744v373h372v-373h-372zM1586 744v373h745v-373h-745zM841 1117v372h373v-372h-373zM1214 1489v372h372v-372h-372zM1586 1861v373h372v-373h-372z M469 2234v372h745v-372h-745zM1958 2234v372h373v-372h-373zM97 2606v372h372v-372h-372zM1214 2606v372h372v-372h-372zM2331 2606v372h372v-372h-372zM469 2978v373h745v-373h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 2426,
    d: "M469 -18.0996v372h1107.5v-372h-1107.5zM1956.5 -18.0996v372h372v-372h-372zM1214 353.9v745h742.5v-745h-742.5zM97 353.9v1117h736.5v-1117h-736.5zM841 1098.9v372h745.5v-372h-745.5zM1956.5 1098.9v372h372v-372h-372zM469 1470.9v745h1118v-745h-1118zM97 2215.9 v744h746.5v-744h-746.5zM1214.5 2215.9v744h730.5v-744h-730.5zM469 2959.9v373h1123v-373h-1123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 566,
    d: "M97 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 1310,
    d: "M470.5 -744v372h742.5v-372h-742.5zM97 -372v3350h744v-3350h-744zM460.5 2978v373h752.5v-373h-752.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 1310,
    d: "M97 -737v372h744v-372h-744zM459 -365v3350h754v-3350h-754zM97 2985v373h744v-373h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 1311,
    d: "M97 1861v373h372v-373h-372zM841 1861v373h373v-373h-373zM469 2234v372h372v-372h-372zM97 2606v372h372v-372h-372zM841 2606v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 2055,
    d: "M841 372v745h-744v372h744v745h373v-745h744v-372h-744v-745h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 938,
    d: "M97 -372v372h372v-372h-372zM469 0v372h372v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 938,
    d: "M97 1117v372h744v-372h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 566,
    d: "M97 0v372h372v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 2067,
    d: "M97 1v744h733.5v-744h-733.5zM469 745v745h742.5v-745h-742.5zM841 1490v745h737.5v-745h-737.5zM1214 2235v1117h756v-1117h-756z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M469 0v372h1489.5v-372h-1489.5zM97 372v2606h750.5v-2606h-750.5zM1586 372v2606h745.5v-2606h-745.5zM469 2978v373h1494.5v-373h-1494.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 1311,
    d: "M461.5 0v2606h-364.5v372h344.5v373h772.5v-3351h-752.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 2448,
    d: "M97 0v744h765v-372h1489v-372h-2254zM473 744v373h761v-373h-761zM842.5 1117v372h764.5v-372h-764.5zM1224.5 1489v372h754.5v-372h-754.5zM107 2606v372h724.5v-372h-724.5zM1595.5 1861v1117h755.5v-1117h-755.5zM479 2978v373h1500v-373h-1500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 2438,
    d: "M460 0v372h1509v-372h-1509zM99 372v372h753v-372h-753zM1582.5 372v1117h758.5v-1117h-758.5zM1224 1489v372h745v-372h-745zM97 2606v372h731.5v-372h-731.5zM1587.5 1861v1117h753.5v-1117h-753.5zM469 2978v373h1500v-373h-1500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 2440,
    d: "M469 1489v745h372v-745h-372zM1214 0v744h-1117v745h372v-372h745v1117h-373v744h373v373h757v-2234h372v-373h-372v-744h-757z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 2440,
    d: "M469 0l1 373l1116 -1v-372h-1117zM97 372v372l728 1v-372zM1586 372v1489l757 1v-1489zM97 1489v1862l2246 1v-373h-1518v-744l761 -1v-373l-761 1v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 2440,
    d: "M469 0v372h1475.5v-372h-1475.5zM1586 372v1117l757 1v-1117zM97 372v2606l732 9.89941v-1117l1115.5 -9.89941v-372h-1123v-1117h-724.5zM1586 2606v372l757 1v-372zM469 2978v373h1480.5v-373h-1480.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 2453,
    d: "M493 0v1117h746v-1117h-746zM867.5 1117v744h744.5v-744h-744.5zM1224.5 1861v745h759.5v-745h-759.5zM1605.5 2606v372h-1508.5v373h2259v-745h-750.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 2441,
    d: "M469 0v372h1475.5v-372h-1475.5zM97 372v1117h724.5v-1117h-724.5zM1586 372v1117h758v-1117h-758zM469 1489v372h1485.5v-372h-1485.5zM97 1861v1117h729.5v-1117h-729.5zM1586 1861v1117h750v-1117h-750zM469 2978v373h1465.5v-373h-1465.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 2440,
    d: "M469 0v372l1502 1v-372zM97 372v372h734.5v-372h-734.5zM97 1861v1117h729.5v-1117h-729.5zM1587.5 373v1117l-1118.5 -1v372l1113.5 1v1117h760.5v-2606h-755.5zM469 2978v373l1502 1v-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 566,
    d: "M97 0v372h372v-372h-372zM97 1861v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 938,
    d: "M97 -372v372h372v-372h-372zM469 0v372h372v-372h-372zM469 1861v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 2055,
    d: "M97 744v373h1861v-373h-1861zM97 1489v372h1861v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 2055,
    d: "M841 0v372h373v-372h-373zM841 744v745h373v-745h-373zM1214 1489v372h372v-372h-372zM97 2606v372h372v-372h-372zM1586 1861v1117h372v-1117h-372zM469 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 3917,
    d: "M1214 -372v372h1861v-372h-1861zM469 0v744h372v-372h373v-372h-745zM1586 744v373h745v-373h-745zM1214 1117v744h372v-744h-372zM97 744v1490h372v-1490h-372zM2331 1117v744h-745v373h1117v-1117h-372zM2703 744v373h745v1117h372v-1490h-1117zM469 2234v744h745v-372 h-373v-372h-372zM3075 2234v372h-372v372h745v-744h-373zM1214 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 3172,
    d: "M97 0v744l744 1v-744zM2329 -6v744l746 7v-744zM479 745v1117h734v-744l747 4v744l743 -4v-1117h-2224zM848.5 1862v745h737.5v-745h-737.5zM1591.5 1862v745h738.5v-745h-738.5zM1220.5 2607v745h737.5v-745h-737.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    d: "M1592.5 384v1117h738.5v-1117h-738.5zM1590.5 1873v1117h740.5v-1117h-740.5zM97 0v3351l1862 12v-373h-1117v-1117h1117v-372h-1117v-1117h1117v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 2800,
    d: "M841 0v372h1489v-372h-1489zM1956.5 372v372h746.5v-372h-746.5zM97 372v2606h744v-2606h-744zM1951.5 2606v372h751.5v-372h-751.5zM841 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 2800,
    d: "M1588.5 372v372h741.5v-372h-741.5zM1956.5 744v1862h746.5v-1862h-746.5zM1583.5 2606v372h746.5v-372h-746.5zM97 0v3351h1861v-373h-1117v-2606h1117v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M97 0v3351l2234 1v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    d: "M97 0v3351h2234v-373h-1489v-1117h1117v-372h-1117v-1489h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 2800,
    d: "M455 0v372h1131v-372h-1131zM1958 0v372h-372v372h372v745h-744v372h1489v-1861h-745zM97 372l-2 2588h750l-4 -2588h-744zM1950 2606v356h750v-356h-750zM455 2960v395l1870 -2v-393h-1870z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 2800,
    d: "M97 0v3351h744v-1490h1116.5v1490h745.5v-3351h-745.5v1489h-1116.5v-1489h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 938,
    d: "M97 0v3351h744v-3351h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 2055,
    d: "M841 1v372h745v-372h-745zM97 372v745l744 1v-745zM1209.5 373v2979h748.5v-2979h-748.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 2800,
    d: "M1951.5 1v372h751.5v-372h-751.5zM1588.5 373v372h741.5v-372h-741.5zM1217.5 745v373h740.5v-373h-740.5zM835.5 1118v372h750.5v-372h-750.5zM830.5 2235v372h755.5v-372h-755.5zM1212.5 2607v372h745.5v-372h-745.5zM97 0v3351l744 1v-1117h372v-745h-372v-1489z M1588.5 2979v373h741.5v-373h-741.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    d: "M97 0v3351l745 1v-2979h1489v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 3550,
    d: "M1210.5 1489v385h740.5v-385h-740.5zM841 1876v365h1481.5v-365h-1481.5zM841 2604.9v354.899l373 -1.10059v-355.899zM471 2233v371.899h1122.5v-371.899h-1122.5zM97 0v3351h740.5v-391.1h3.5v-355.001h-372v-2604.9h-372zM2712 0v2238.9h-759.5v366.102 l374.5 -0.100586l5 355.001l375 1v390.1h745.5v-3351h-740.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 2800,
    d: "M1207.5 1117l-6.5 756h755l2 -756h-750.5zM835.5 1489v745h750.5v-745h-750.5zM97 0v3351h744v-373h372v-744h-372v-2234h-744zM1961.5 0v372h-373v745h368v2234h746.5v-3351h-741.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 2800,
    d: "M471 1v372h1859v-372h-1859zM97 372v2606l744 1v-2606zM1951.5 373v2606h751.5v-2606h-751.5zM471 2979v373h1859v-373h-1859z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 2798,
    d: "M1948 1861v1117h752.5v-1117h-752.5zM97 0v3351h2230.5v-373h-1489v-1117h1489v-372h-1489v-1489h-741.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 2800,
    d: "M1957.5 -372v372h745.5v-372h-745.5zM1213.5 744v373h372v-373h-372zM97 372v2606h744v-2606h-744zM476 0v372h1109.5v372h372v2234h745.5v-2606h-373v-372h-1854zM476 2978v373h1844v-373h-1844z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 2800,
    d: "M1951.5 0v1489h751.5v-1489h-751.5zM1951.5 1861v1117h751.5v-1117h-751.5zM97 0v3351h2233v-373h-1489v-1117h1489v-372h-1489v-1489h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 2424,
    d: "M483.5 0v372h1472v-372h-1472zM97 372v372h741.5v-372h-741.5zM1591 372v1117h736.5v-1117h-736.5zM473.5 1489v372h1482v-372h-1482zM97 1861v1117h741.5v-1117h-741.5zM1581 2606v372h746.5v-372h-746.5zM468.5 2978v373h1487v-373h-1487z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    d: "M841 0v2978h-744v373h2233.5v-373h-744v-2978h-745.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 2800,
    d: "M469 0v372h1861.5v-372h-1861.5zM97 372v2979h739.5v-2979h-739.5zM1958 372v2979h745v-2979h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 3170,
    d: "M1214 0v744h738.5v-744h-738.5zM841 744v745h743.5v-745h-743.5zM1586 744v745l742 2v-745zM469 1489v1117h743.5v-1117h-743.5zM1958 1489v1117h746.5v-1117h-746.5zM97 2606v745h744.5v-745h-744.5zM2331 2606v745h742v-745h-742z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 4658,
    d: "M1214 0v744l737 -8v-744zM2703 0v744h752v-744h-752zM841 744v745h742.5v-745h-742.5zM1586 744v745l747 -3v-745zM2331 744v745h742v-745h-742zM3075 744v745h743v-745h-743zM469 1489v1117l742 -3v-1117zM1958 1489v1117h740.5v-1117h-740.5zM3448 1489v1117h732v-1117 h-732zM97 2606v745l742 -0.0996094v-745zM3820 2606v745h741v-745h-741z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 3171,
    d: "M97 0v744l743 1v-744zM2328.5 1v744h745.5v-744h-745.5zM479 745v373h733v-373h-733zM1949.5 745v373h752.5v-373h-752.5zM843.5 1118v372h741.5v-372h-741.5zM1589.5 1118v372h739.5v-372h-739.5zM1220.5 1490v372h736.5v-372h-736.5zM848.5 1862v373h736.5v-373h-736.5 zM1576.5 1862v373h752.5v-373h-752.5zM474 2235v372h738v-372h-738zM1959.5 2235v372h742.5v-372h-742.5zM97 2606v745l743 1v-745zM2328.5 2607v745h745.5v-745h-745.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 3172,
    d: "M1216.5 0v1861h741.5v-1861h-741.5zM839.5 1861v373h746.5v-373h-746.5zM1587.5 1861v373h742.5v-373h-742.5zM468 2234v372h745v-372h-745zM1953 2234v372h750v-372h-750zM97 2606v745h744v-745h-744zM2329.5 2606v745h745.5v-745h-745.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 3172,
    d: "M97 0v744h744v-372h2234v-372h-2978zM468 744v373h745v-373h-745zM839.5 1117v372h746.5v-372h-746.5zM1216.5 1489v372h741.5v-372h-741.5zM1582.5 1861v373h747.5v-373h-747.5zM1955.5 2234v372h747.5v-372h-747.5zM2329.5 2606v372h-2232.5v373h2978v-745h-745.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 938,
    d: "M97 -744v4095h744v-373h-372v-3350h372v-372h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 2074,
    d: "M1214 1v744h763v-744h-763zM841 745v745h749.5v-745h-749.5zM469 1490v745l747 3v-745zM97 2235v1117h730.5v-1117h-730.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 938,
    d: "M97 -744v372h372v3350h-372v373h744v-4095h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 2055,
    d: "M97 2606v372h372v-372h-372zM1586 2606v372h372v-372h-372zM469 2978v373h372v-373h-372zM1214 2978v373h372v-373h-372zM841 3351v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    d: "M97 -372v372h2234v-372h-2234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 2427,
    d: "M97 372v745h745.5v-745h-745.5zM469 0v372h1117v745h-1117v372h1117v372h744v-1861h-1861zM469 1861v373h1487.5v-373h-1487.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 2426,
    d: "M1585 372v1501l740 3l4 -1504h-744zM97 0v3351h735.5v-1117l1117.5 -1v-358l-1105 -2l-2.5 -1501l1107.5 2v-374h-1853z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 2055,
    d: "M469 -1v372h1117v-372h-1117zM1210.5 371v372h747.5v-372h-747.5zM97 371v1489h748.5v-1489h-748.5zM1217 1488v372h737.5v-372h-737.5zM469 1860v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 2426,
    d: "M97 372v1489h750.5v-1489h-750.5zM469 0v372h1117v1489h-1117v373h1117v1117h743v-3351h-1860z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 2427,
    d: "M469 0v372h1489v-372h-1489zM1586.5 372v372h743.5v-372h-743.5zM97 372v1489h745.5v-372h744v372h743.5v-744h-1487.5v-745h-745.5zM469 1861v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 1311,
    d: "M97 0v2978h741.5v-744h372v-373h-372v-1861h-741.5zM466 2978v373h748v-373h-748z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 2437,
    d: "M97 -744v372h1865.5v-372h-1865.5zM97 372v1489h747v-1489h-747zM1586 -372v372h-1117v372h1117v1489h-1117v373h1871v-2606h-754z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 2422,
    d: "M1586 0v1861h739.5v-1861h-739.5zM838 1861v373h1115.5v-373h-1115.5zM97 0v3351h739.5v-1490h372v-372h-372v-1489h-739.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 938,
    d: "M97 0v2234h744v-2234h-744zM97 2978v373h744v-373h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 938,
    d: "M97 -744v2978h744v-2978h-744zM97 2978v373h744v-373h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    d: "M1584 0v372h747v-372h-747zM1203.5 372v372h755.5v-372h-755.5zM840.5 744v373h746.5v-373h-746.5zM836.5 1489v372h750.5v-372h-750.5zM1208.5 1861v373h750.5v-373h-750.5zM97 0v3351h745v-1862h372v-372h-372v-1117h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 938,
    d: "M97 0v3351h744v-3351h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 3170,
    d: "M1210 0v1861h745.5v-1861h-745.5zM2331 0v1861h741.5v-1861h-741.5zM97 0v2234h1858v-373h-1116.5v-1861h-741.5zM1955.5 1861v373h745v-373h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 2427,
    d: "M1585.5 0v1861h744.5v-1861h-744.5zM97 0v2234h744v-373h372v-372h-372v-1489h-744zM841 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    d: "M469 0v372h1490v-372h-1490zM97 372v1489h739.5v-1489h-739.5zM1581.5 372v1489h749.5v-1489h-749.5zM469 1861v373h1490v-373h-1490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 2424,
    d: "M1581 372v1489h746.5v-1489h-746.5zM97 -744v2978h1858.5v-373h-1117v-1489h1117v-372h-1117v-744h-741.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 2427,
    d: "M97 372v1489h741.5v-1489h-741.5zM1586 -744v744h-1117v372h1117v1489h-1117v373h1861v-2978h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 1310,
    d: "M97 0v2234h1116v-373h-372v-1861h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 2055,
    d: "M469 0v372h1117v-372h-1117zM97 372v372h739.5v-372h-739.5zM1217.5 372v372h740.5v-372h-740.5zM841 744v373h745v-373h-745zM469 1117v372h741.5v-372h-741.5zM97 1489v372h742.5v-372h-742.5zM1211.5 1489v372h746.5v-372h-746.5zM469 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 1311,
    d: "M474 0v372h740v-372h-740zM97 372v2606h745v-744h372v-373h-372v-1489h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 2427,
    d: "M469 0v372h1119.5v-372h-1119.5zM97 372v1862h745.5v-1862h-745.5zM1586 0v372h-372v372h372v1490h744v-2234h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    d: "M841 0v744h746v-744h-746zM469 744v745h741.5v-745h-741.5zM1212.5 744v745h746.5v-745h-746.5zM97 1489v745h743.5v-745h-743.5zM1586.5 1489v745h744.5v-745h-744.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 3170,
    d: "M469 372v759h372v-759h-372zM2328.5 373v755h373v-755h-373zM841 -5v1134h373v-1134h-373zM1956.5 4l0.5 1129h371.5v-1129h-372zM97 1132v1102h745.5v-1102h-745.5zM1215 742l-1 1492l740.5 -1l4 -1492zM2333 1128v1106h740.5v-1106h-740.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 2051,
    d: "M97 0v744h740v-744h-740zM1211.5 0v744h742.5v-744h-742.5zM474 744v745l1113.5 -3v-745zM97 1489v745h740v-745h-740zM1213.5 1489v745h740.5v-745h-740.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    d: "M469 743v744h1487v-744h-1487zM468 -744v744h744v-744h-744zM842 370v372l744 1v-742l-745 -1v370h1zM97 1487v745h742.5v-745h-742.5zM1586 1489v744h745.5v-744h-745.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 2055,
    d: "M97 0v744h744v-372h1117v-372h-1861zM469 741v373l744 3v-373zM839.5 1111v372l746.5 6v-372zM1211.5 1489v372h-1114.5v373h1861v-745h-746.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 1311,
    d: "M841 -372v372h373v-372h-373zM469 0v1489h372v-1489h-372zM97 1489v372h372v-372h-372zM469 1861v1490h372v-1490h-372zM841 3351v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 1311,
    d: "M97 -372v372h372v-372h-372zM469 0v1489h372v-1489h-372zM841 1489v372h373v-372h-373zM469 1861v1490h372v-1490h-372zM97 3351v372h372v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M97 2234v372h372v-372h-372zM1214 2234v372h744v-372h-744zM469 2606v372h745v-372h-745zM1958 2606v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 566,
    d: "M97 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 566,
    d: "M97 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 1683,
    d: "M97 2234v1117h372v-1117h-372zM1214 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 1683,
    d: "M97 2234v1117h372v-1117h-372zM1214 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 2798,
    d: "M1581.5 -744v372h373v-372h-373zM1581.5 -372zM1208.5 -372v372h373v-372h-373zM1208.5 0zM838.5 0v372h1489v-372h-1489zM1952 372v372h748.5v-372h-748.5zM97 372v2606h741.5v-2606h-741.5zM1947 2606v372h753.5v-372h-753.5zM838.5 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 2424,
    d: "M1581.5 3354v372h373v-372h-373zM1581.5 3726zM1208.5 3726v372h373v-372h-373zM1208.5 4098zM97 0v3351h2230.5v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372h-2230.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M1957 3727h-372v373h372v-373zM1585 3727zM1585 3354h-372v373h372v-373zM1213 3354zM97 0v3351l2234 1v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 3172,
    d: "M1584 3354v372h373v-372h-373zM1584 3726zM1211 3726v372h373v-372h-373zM1211 4098zM97 0v744h744v-744h-744zM2328 -2v744l747 2v-744zM475 744v1117h738l-1 -728l748 -7v744l743 -9v-1117h-2228zM838 1859v745l748 2v-745zM1582.5 1861v745h747.5v-745h-747.5z M1211.5 2606v745h746.5v-745h-746.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 3172,
    d: "M1584.5 3352h-372v373h372v-373zM1212.5 3352zM97 0v744h744v-744h-744zM2328 -2v744l747 2v-744zM475 744v1117h738l-1 -728l748 -7v744l743 -9v-1117h-2228zM838 1859v745l748 2v-745zM1582.5 1861v745h747.5v-745h-747.5zM1211.5 2606v745h746.5v-745h-746.5z M1957.5 3726h-372v373h372v-373zM1585.5 3726z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M1956 3727zM1956 3727zM1956 3354h-372v373h372v-373zM1584 3354zM1585 3727h-372v373h372v-373zM1213 3727zM1213 3354h-372v373h372v-373zM841 3354zM97 0v3351l2234 1v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 3172,
    d: "M1957.5 3726zM1584.5 3726v372h373v-372h-373zM1584.5 4098zM1955.5 3358v372h373v-372h-373zM1584 3726zM1211 3354v372h373v-372h-373zM97 0v744h744v-744h-744zM2328 -2v744l747 2v-744zM475 744v1117h738l-1 -728l748 -7v744l743 -9v-1117h-2228zM838 1859v745l748 2 v-745zM1582.5 1861v745h747.5v-745h-747.5zM1211.5 2606v745h746.5v-745h-746.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 2427,
    d: "M469 0v372h1489v-372h-1489zM1586.5 372v372h743.5v-372h-743.5zM97 372v1489h745.5v-372h744v372h743.5v-744h-1487.5v-745h-745.5zM469 1861v373h1489v-373h-1489zM1212 2604v372h373v-372h-373zM1212 2976zM839 2976v372h373v-372h-373zM839 3348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 2427,
    d: "M469 0v372h1489v-372h-1489zM1586.5 372v372h743.5v-372h-743.5zM97 372v1489h745.5v-372h744v372h743.5v-744h-1487.5v-745h-745.5zM469 1861v373h1489v-373h-1489zM1584 2981h-372v373h372v-373zM1212 2981zM1212 2608h-372v373h372v-373zM840 2608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 2427,
    d: "M469 0v372h1489v-372h-1489zM1586.5 372v372h743.5v-372h-743.5zM97 372v1489h745.5v-372h744v372h743.5v-744h-1487.5v-745h-745.5zM469 1861v373h1489v-373h-1489zM1583 2981zM1583 2981zM1583 2608h-372v373h372v-373zM1211 2608zM1212 2981h-372v373h372v-373z M840 2981zM840 2608h-372v373h372v-373zM468 2608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 2427,
    d: "M469 0v372h1489v-372h-1489zM1586.5 372v372h743.5v-372h-743.5zM97 372v1489h745.5v-372h744v372h743.5v-744h-1487.5v-745h-745.5zM469 1861v373h1489v-373h-1489zM1583 2976zM1583 2976zM1583 2603h-372v373h372v-373zM1211 2603zM840 2603h-372v373h372v-373z M468 2603z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M1956 3727zM1956 3727zM1956 3354h-372v373h372v-373zM1584 3354zM1213 3354h-372v373h372v-373zM841 3354zM97 0v3351l2234 1v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 2055,
    d: "M469 0v372h1117v-372h-1117zM1586 372v372h372v-372h-372zM97 372v1489h748.5v-1489h-748.5zM1586 1489v372h368.5v-372h-368.5zM469 1861v373h1117v-373h-1117zM1212 -744v372h373v-372h-373zM1212 -372zM839 -372v372h373v-372h-373zM839 0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 2427,
    d: "M97 372v745h745.5v-745h-745.5zM469 0v372h1117v745h-1117v372h1117v372h744v-1861h-1861zM469 1861v373h1487.5v-373h-1487.5zM1212 2604v372h373v-372h-373zM1212 2976zM839 2976v372h373v-372h-373zM839 3348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 2432,
    d: "M1585 4v372h378v-372h-378zM1574.5 376v372h760.5v-372h-760.5zM1213 376v1489h372v-372h378v372h372v-744h-750v-745h-372zM1585 1865v373h378v-373h-378zM469 0v745l371 4v-745zM97 372v1489h372v-1489h-372zM840 376v1489h372v-1489h-372zM469 1478v756l371 4v-756z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 3464,
    d: "M2960.85 242.75zM2551.65 242.75v409.2h815.65v-409.2h-815.65zM506.2 242.75zM97 242.75v409.2h815.65v-409.2h-815.65zM2960.85 2699.05zM2551.65 2699.05v409.2h815.65v-409.2h-815.65zM506.2 2697.95zM97 2697.95v409.2h815.65v-409.2h-815.65zM506.2 650.85v410.301 h810.15v-410.301h-810.15zM2144.1 650.85v410.301h819.5v-410.301h-819.5zM915.4 1061.15v409.199h1229.8v-409.199h-1229.8zM2144.1 1061.15v409.199h409.2v-409.199h-409.2zM1325.7 1470.35v409.2h818.4v-409.2h-818.4zM915.4 1879.55v410.3h1229.8v-410.3h-1229.8z M2144.1 1879.55v410.3h409.2v-410.3h-409.2zM506.2 2289.85v409.2h815.65v-409.2h-815.65zM2143.55 2289.85v409.2h820.05v-409.2h-820.05z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    d: "M1583 2981zM1583 2981zM1583 2608h-372v373h372v-373zM1211 2608zM1212 2981h-372v373h372v-373zM840 2981zM840 2608h-372v373h372v-373zM468 2608zM469 0v372h1490v-372h-1490zM97 372v1489h735.5v-1489h-735.5zM1576.5 366v1489l754.5 6v-1489zM469 1861v373h1490 v-373h-1490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 2427,
    d: "M97 372v745h745.5v-745h-745.5zM469 0v372h1117v745h-1117v372h1117v372h744v-1861h-1861zM469 1861v373h1487.5v-373h-1487.5zM1583 2981zM1583 2981zM1583 2608h-372v373h372v-373zM1211 2608zM1212 2981h-372v373h372v-373zM840 2981zM840 2608h-372v373h372v-373z M468 2608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 2427,
    d: "M469 0v372h1119.5v-372h-1119.5zM97 372v1862h745.5v-1862h-745.5zM1586 0v372h-372v372h372v1490h744v-2234h-744zM1583 2981zM1583 2981zM1583 2608h-372v373h372v-373zM1211 2608zM1212 2981h-372v373h372v-373zM840 2981zM840 2608h-372v373h372v-373zM468 2608z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 1702,
    d: "M829 1852v358h763v-358h-763zM842 1v372h763v-372h-763zM469 373v387h749.5v-387h-749.5zM97 758v728l747 3v-728zM463 1492.1l-0.5 358.799h730.5l0.5 -358.799h-730.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 1702,
    d: "M873 1855v358h-763v-358h763zM860 1v372h-763v-372h763zM1233 373v387h-749.5v-387h749.5zM1605 758v731l-747 3v-731zM1239 1495.1l0.5 358.799h-730.5l-0.5 -358.799h730.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsSansSerifBold2);
export default __webpack_public_path__ + "static/media/MS-Sans-Serif-bold2.bc246637aecba8d67f87deb06810f1a4.svg";
export { ForwardRef as ReactComponent };